/**
 * Curated whiteboard drawing vocabulary for the coaching-instructions editor.
 * Each item: { id (the token used in the play JSON / prompt), name (dropdown label), group }.
 * Sourced from the whiteboard factories (cn_line.js / cn_pen.js / cn_player.js),
 * the route tree + backgrounds in MessageBoardController's SPEC, and
 * WhiteboardPlay::predefinedTemplates(). Static on purpose — these names are the
 * same ones get_formation and the draw tools already understand.
 */
const line = (id, desc) => ({ id, name: `${id} — ${desc}`, group: "Lines" });
const route = (id) => ({ id, name: `${id} route`, group: "Routes" });
const formation = (id) => ({
    id,
    name: `${id} (formation)`,
    group: "Formations",
});
const player = (id, desc) => ({
    id,
    name: `${desc} (${id})`,
    group: "Players",
});
const background = (path) => ({
    id: path,
    name: path.split("/").pop().replace(".jpg", ""),
    group: "Backgrounds",
});

export const COACHING_VOCAB = [
    // --- Lines / route styles (which line to use) ---
    line("multilineArrow", "route arrow (solid)"),
    line("multiline", "line (solid, no arrow)"),
    line("multilineDotted", "dotted line (motion / coverage)"),
    line("multilineDashedArrow", "dashed arrow (motion into route)"),
    line("multilineHammer", "block (T / hammer end)"),
    line("penSquigglyArrow", "squiggly arrow (scramble)"),
    line("penSquigglyTab", "squiggly tab"),
    line("penArrow", "freehand arrow"),
    line("penDottedArrow", "freehand dotted arrow"),
    line("pen", "freehand line"),
    line("penDotted", "freehand dotted line"),
    line("penTab", "freehand tab"),
    line("bezierLine", "curved line"),
    line("bezierLineDashed", "curved dashed line"),
    line("bezierLineTab", "curved tab line"),
    line("bezierLineTabDashed", "curved dashed tab line"),

    // --- Routes (route tree) ---
    route("Go"),
    route("Fly"),
    route("Streak"),
    route("Hitch"),
    route("Curl"),
    route("Flat"),
    route("Swing"),
    route("Screen"),
    route("Cross"),
    route("Drag"),
    route("Corner"),
    route("Flag"),
    route("Post"),
    route("Out"),
    route("In"),
    route("Dig"),
    route("Slant"),
    route("Angle"),

    // --- Formations (templates get_formation resolves) ---
    formation("I-Formation"),
    formation("Shotgun"),
    formation("Single Back"),
    formation("Spread"),
    formation("Trips"),
    formation("4-3"),
    formation("3-4"),
    formation("4-2-5"),
    formation("Dime"),
    // basketball
    formation("Base"),
    formation("2 - 3"),
    formation("2 - 1 - 2"),
    formation("1 - 3 - 1"),
    formation("Perimeter"),
    formation("Box-n-One"),
    formation("3 - 2"),

    // --- Players (core football tokens) ---
    player("offense:q", "QB"),
    player("offense:h", "Halfback"),
    player("offense:f", "Fullback"),
    player("offense:x", "X receiver"),
    player("offense:y", "Y receiver"),
    player("offense:z", "Z receiver"),
    player("offense:te", "Tight End"),
    player("ShadedCross", "5-man O-line"),
    player("defense:de", "Def End"),
    player("defense:dt", "Def Tackle"),
    player("defense:nt", "Nose Tackle"),
    player("defense:m", "Mike LB"),
    player("defense:w", "Will LB"),
    player("defense:s", "Sam LB"),
    player("defense:cb", "Cornerback"),
    player("defense:fs", "Free Safety"),
    player("defense:ss", "Strong Safety"),

    // --- Backgrounds ---
    background("/default-images/backgrounds/football-college-half.jpg"),
    background("/default-images/backgrounds/football-college.jpg"),
    background("/default-images/backgrounds/football-pro.jpg"),
    background("/default-images/backgrounds/football-pro-half.jpg"),
    background("/default-images/backgrounds/basketball.jpg"),
    background("/default-images/backgrounds/basketball-half.jpg"),
    background("/default-images/backgrounds/soccer.jpg"),
    background("/default-images/backgrounds/soccer-half.jpg"),
    background("/default-images/backgrounds/hockey.jpg"),
    background("/default-images/backgrounds/hockey-half.jpg"),
    background("/default-images/backgrounds/lacrosse-full.jpg"),
    background("/default-images/backgrounds/lacrosse-half.jpg"),
    background("/default-images/backgrounds/field-hockey-full.jpg"),
    background("/default-images/backgrounds/field-hockey-half.jpg"),
    background("/default-images/backgrounds/volley-ball-full.jpg"),
    background("/default-images/backgrounds/volley-ball-half.jpg"),
];
